// STEPS
export const MAIN_DATA_STEP: string = 'data';
export const INFO_STEP: string = 'info';
export const ELEMENTS_STEP: string = 'elements';
export const CONTENT_STEP: string = 'content';

// MAIN_DATA_STEP
export const TYPE_FIELD: string = 'type';
export const SUBTYPE_FIELD: string = 'subtype';
export const PRIMARY_APPROVING_BODY_FIELD: string = 'primaryApprovingBody';
export const NOMINAL_SUBDIVISION_FIELD: string = 'nominalSubdivision';
export const SECONDARY_APPROVING_BODY_FIELD: string = 'secondaryApprovingBody';
export const SECONDARY_APPROVING_BODY_SUB_FIELD: string = 'secondaryApprovingBodySub';
export const PROVISION_NUMBER_FIELD: string = 'provisionNumber';
export const ACTION_TYPE_FIELD: string = 'actionType';
export const APPROVAL_DATE_FIELD: string = 'approvalDate';
export const EFFECTIVE_DATE_FIELD: string = 'effectiveDate';
export const PUBLICATION_DATE_FIELD: string = 'publicationDate';
export const PUBLICATION_USER_FIELD: string = 'publicationUser';
export const BOUD_RECORD_ID_FIELD: string = 'boudRecordId';
export const OBSERVATIONS_FIELD: string = 'observations';
export const PARTIAL_REPEAL_FIELD: string = 'partialRepeal';

// ELEMENTS_STEP
export const CORRECTED_ELEMENTS_FIELD: string = 'correctedElements';
export const MODIFIED_ELEMENTS_FIELD: string = 'modifiedElements';
export const SUSPENDED_ELEMENTS_FIELD: string = 'suspendedElements';
export const REPEALED_ELEMENTS_FIELD: string = 'repealedElements';
export const MENTIONED_ELEMENTS_FIELD: string = 'mentionedElements';

// ELEMENTS_STEP (References)
export const MENTIONERS_ELEMENTS_FIELD: string = 'mentionersElements';
export const MODIFIERS_ELEMENTS_FIELD: string = 'modifiersElements';
export const REPEALERS_ELEMENTS_FIELD: string = 'repealersElements';
export const SUSPENDERS_ELEMENTS_FIELD: string = 'suspendersElements';
export const CORRECTORS_ELEMENTS_FIELD: string = 'correctorsElements';


// CONTENTS_STEP
export const EUSKERA_CONTENT_FIELD: string = 'euskeraContent';
export const SPANISH_CONTENT_FIELD: string = 'spanishContent';
export const ENGLISH_CONTENT_FIELD: string = 'englishContent';